import { isScrolledIntoView } from './scrolled-into-view';
import { animateStat } from './animate-stat';

export const animateStats = {
    init: () => {
        const $ = jQuery;

        const stats = $('.stat-wrapper');

        if (stats.length === 0) {
            return false;
        }

        $.each(stats, (i, stat) => {
            $(window).on('scroll', () => {
                if ( isScrolledIntoView($(stat)) ) {
                    $(stat).addClass('animation-started');
                    animateStat(stat);
                }
            });
        });
    }
}